import { render, staticRenderFns } from "./CategoryReg.vue?vue&type=template&id=7eafda57&scoped=true"
import script from "./CategoryReg.vue?vue&type=script&lang=js"
export * from "./CategoryReg.vue?vue&type=script&lang=js"
import style0 from "./CategoryReg.vue?vue&type=style&index=0&id=7eafda57&prod&lang=stylus&scoped=true"
import style1 from "./CategoryReg.vue?vue&type=style&index=1&id=7eafda57&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eafda57",
  null
  
)

export default component.exports